import { render, staticRenderFns } from "./InviteToHub.vue?vue&type=template&id=4589d1ee&scoped=true&"
import script from "./InviteToHub.vue?vue&type=script&lang=js&"
export * from "./InviteToHub.vue?vue&type=script&lang=js&"
import style0 from "./InviteToHub.vue?vue&type=style&index=0&id=4589d1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589d1ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
